import { inject, injectable } from 'inversify'
import {
  DeleteCompanyArticleUseCaseInput,
  DeleteCompanyArticleUseCaseOutput,
  IAppErrorFactory,
  IArticlesService,
  IDeleteCompanyArticleUseCase,
} from '../../types'
import symbols from '../../symbols'

@injectable()
export default class DeleteCompanyArticleInteractor implements IDeleteCompanyArticleUseCase {
  @inject(symbols.IArticlesService) private articlesService: IArticlesService

  @inject(symbols.IAppErrorFactory) private errorFactory: IAppErrorFactory

  async handle(input: DeleteCompanyArticleUseCaseInput): Promise<DeleteCompanyArticleUseCaseOutput> {
    const output = this.getDefaultOutputData()
    try {
      output.article = await this.articlesService.deleteCompanyArticle({
        id: input.id,
      })
    } catch (e) {
      output.error = this.errorFactory.create({
        originalInstance: e as Error,
      })
    }

    return output
  }

  private getDefaultOutputData(): DeleteCompanyArticleUseCaseOutput {
    return {
      article: null,
      error: null,
    }
  }
}
